import { shortId } from './shortId';

/**
 * Regex de UUID GENÉRICA (cualquier versión/variante, case-insensitive). NO restringimos a v4 a
 * propósito: el backend del rbac puede emitir ids que no son v4, y solo nos importa "¿esto tiene
 * forma de UUID?" para decidir si es un id crudo que se nos coló como si fuera un nombre.
 */
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** ¿`value` tiene forma de UUID (match EXACTO)? Sirve para detectar ids crudos disfrazados de nombre. */
export function isUuid(value: string | null | undefined): boolean {
    return !!value && UUID_RE.test(value);
}

/**
 * Devuelve un texto legible para mostrar al usuario a partir de un posible nombre + el id de respaldo.
 *
 * DEC-013: defensa contra la CLASE de bug "id crudo disfrazado de nombre". El backend del rbac puebla
 * `scopeRefName` (y otros `*Name`) con el id crudo como fallback cuando no tiene el nombre real
 * (`scopeRefName ?? scopeRef`). Así, los consumidores que confiaban en `name ?? shortId(id)` terminaban
 * mostrando el UUID completo igual, porque `name` ya venía siendo el UUID. Este helper corta esa fuga:
 *
 *  - Si `name` existe, NO está vacío, y NO tiene forma de UUID ni es exactamente igual al id → se usa `name`.
 *  - En cualquier otro caso (ausente / vacío / uuid-shaped / == id) → `shortId(id)` (8 chars + elipsis).
 *
 * El caller SIEMPRE debe etiquetar el resultado por tipo ("Grupo: …", "Retailer: …") — igual que con
 * `shortId`. Ver docs/CONVENCIONES_FRONTEND.md "Regla anti-UUID en UI".
 */
export function displayNameOrShort(name: string | null | undefined, id: string): string {
    if (name && name !== id && !isUuid(name)) return name;
    return shortId(id);
}
